import { Injectable } from '@angular/core';
import { ServiceBase } from '@app/core/services/service-base.service';
import { ReplaySubject, Subject } from 'rxjs';
import { ActionMode } from '../components/draw-detail-container/models/common';

@Injectable({
    providedIn: 'root'
})
export class DrawerService<T> extends ServiceBase {

    public openBehavior = new ReplaySubject<boolean>(0);
    public openRequested = this.openBehavior.asObservable();
    public isOpen: boolean = false;

    public actionModeChanged: ReplaySubject<ActionMode> = new ReplaySubject<ActionMode>(1);
    private _actionMode: ActionMode = ActionMode.view;

    public get actionMode(): ActionMode {
        return this._actionMode;
    }

    public set actionMode(value: ActionMode) {
        this._actionMode = value;
        this.actionModeChanged.next(value);
    }

    public model: T;

    public actionModes = ActionMode;
    constructor() {
        super();
    }

    public open(data: T, actionMode: ActionMode): void {
       
        if (this.model !== data || !this.isOpen) {
            this.model = data;
            this.openBehavior.next(true);
            this.isOpen = true;
        } else {
            this.openBehavior.next(false);
            this.isOpen = false;
        }
        this.actionMode = actionMode;


    }

    public close(): void {
        this.actionMode = ActionMode.view;
        this.model = null;
        this.openBehavior.next(false);
    }
}
